import {FormControl, FormField} from 'platform/components';
import {Box, HStack, Show} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import i18n from '@dms/i18n';

import {SingleLocationFormValue} from './SingleLocationFormValue';

interface SimpleVectorRowProps {
  index: number;
  isSelectVisible: boolean;
  control: FormControl<SingleLocationFormValue>;
  formApi: UseFormReturn<SingleLocationFormValue>;
}

export function SimpleVectorRow(props: SimpleVectorRowProps) {
  const isSelected = useWatch({
    control: props.control,
    name: `storageLocation.${props.index}.isSelected`,
  });

  return (
    <HStack spacing={4} align="center">
      <Show when={props.isSelectVisible}>
        <Box width={5}>
          <FormField
            type="checkbox"
            name={`storageLocation.${props.index}.isSelected`}
            control={props.control}
            onChange={() => props.formApi.trigger()}
          />
        </Box>
      </Show>
      <Box flex={1}>
        <FormField
          type="choice"
          name={`storageLocation.${props.index}.vectorType`}
          control={props.control}
          options={[
            {
              label: i18n.t('entity.tireWarehouses.labels.aisle'),
              value: 'AISLE',
            },
            {
              label: i18n.t('entity.tireWarehouses.labels.rack'),
              value: 'RACK',
            },
            {
              label: i18n.t('entity.tireWarehouses.labels.level'),
              value: 'LEVEL',
            },
            {
              label: i18n.t('entity.tireWarehouses.labels.position'),
              value: 'POSITION',
            },
            {
              label: i18n.t('entity.tireWarehouses.labels.other'),
              value: 'OTHER',
            },
          ]}
          isDisabled
          isNotClearable
        />
      </Box>
      <Box flex={1}>
        <FormField
          type="text"
          name={`storageLocation.${props.index}.symbol`}
          control={props.control}
          isDisabled={!isSelected}
        />
      </Box>
    </HStack>
  );
}
